<template>
    <div class="main-banner-carousel-box">
        <!-- 菜单栏 -->
        <div class="main-menu" 
            @mouseleave="handleLeave">
            <!-- 一级菜单栏 -->
            <main-menu
                :menu-list="menu"
                box-class="main-menu-first"
                font-color="#fff"
                :hover-menu="hover_first"
                :hover-fun="handleFirst">
                <template #menuIcon>
                    <i class="el-icon-arrow-right main-menu-icon"></i>
                </template>
            </main-menu>
            <div class="main-submenu">
                <!-- 二级菜单栏 -->
                <main-menu
                    :menu-list="sec_menu"
                    box-class="main-menu-second"
                    font-color="#606266"
                    :hover-menu="hover_sec"
                    :hover-fun="handleSec"
                    v-if="sec_menu.length && sec_menu.length>0">
                </main-menu>
                <!-- 三级菜单栏 -->
                <main-menu
                    :menu-list="third_menu"
                    box-class="main-menu-second"
                    font-color="#606266"
                    :hover-menu="hover_third"
                    :hover-fun="handleThird"
                    v-if="third_menu.length && third_menu.length>0">
                </main-menu>
            </div>
        </div>
        <!-- 轮播图 -->
        <div class="main-carousel">
            <carousel 
                :autoplay="true" 
                :autoplayTimeout="3000"
                :minSwipeDistance="40" 
                :scrollPerPage="true" 
                :speed="500" 
                :perPage="1" 
                :paginationPadding="10" 
                :paginationSize="10" 
                paginationColor="#fff"
                paginationActiveColor="#ff6700"
                :loop="true"
                :navigationEnabled="true"
                navigationPrevLabel="<span class='glyphicon glyphicon-menu-left'></span>"
                navigationNextLabel="<span class='glyphicon glyphicon-menu-right'></span>">
                <slide v-for="(item,index) of main_carousel" :key="index">
					<div @click="clickSkip(item)">
						<img-main-carousel :src="item.image"></img-main-carousel>
					</div>
                </slide>
            </carousel>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data() {
        return {
            hover_first: -1,
            hover_sec: -1,
            hover_third: -1,
            sec_menu: [],
            third_menu: [],
        }
    },
    computed: mapState({
        main_carousel: state => state.banner.main_carousel,
        menu: state => state.banner.menu,
    }),
    components: {
        mainMenu: () => import("@/components/mainBannerMenu"),
        imgMainCarousel: () => import("@/components/imgMainCarousel")
    },
    methods: {
		clickSkip(item){
			if(item.url){
				window.open(item.url)
			}
			
		},
        handleFirst(id, submenu){
            this.hover_first = id;
            this.sec_menu = submenu;
            this.third_menu = [];
            this.hover_sec = this.hover_third = -1;
        },
        handleSec(id, submenu){
            this.hover_sec = id;
            this.third_menu = submenu;
            this.hover_third = -1;
        },
        handleThird(id){
            this.hover_third = id;
        },
        handleLeave(){
            this.handleFirst(-1, []);
            this.handleSec(-1, []);
            this.handleThird(-1);
        }
    },
}
</script>

<style scoped>
/* 组件盒子 */
/* 菜单栏区域 */
.main-banner-carousel-box>.main-menu{
    position: relative;
    display: inline-block;
    width: 240px;
    height: 400px;
    background-color: rgba(0, 0, 0, 0.616);
}
.main-menu>>>.el-scrollbar__wrap{
    overflow-x: hidden;
}
.main-menu>>>.el-scrollbar__thumb{
    background-color: #fe8729;
}
/* 菜单栏容器公共样式 */
.main-menu-first,
.main-menu-second{
    height: 100%;
    padding: 10px 0;
}
/* 一级菜单 */
.main-menu-icon{
    color: #fff;
}
/* 子菜单容器 */
.main-submenu{
    position: absolute;
    top: 0;
    left: 240px;
    height: 100%;
    z-index: 10;
    display: flex;
}
/* 二级菜单 */
.main-menu-second{
    width: 200px;
    background-color: #fff;
}

/* 轮播图盒子 */
.main-carousel{
    display: inline-block;
    width: 900px;
    height: 400px;
}
/* 轮播图按钮 */
.main-carousel>>>.VueCarousel-navigation-button:focus{
    outline-color: transparent;
}
.main-carousel>>>.VueCarousel-navigation-prev,
.main-carousel>>>.VueCarousel-navigation-next{
    position: absolute;
    padding: 0;
}
.main-carousel>>>.VueCarousel-navigation-prev{
    left: 70px;
}
.main-carousel>>>.VueCarousel-navigation-next{
    right: 70px;
}
/*图标字体样式*/
.main-carousel>>>.VueCarousel-navigation-button>span{
    width: 50px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    font-size: 50px;
    font-weight: lighter;
    color: rgb(193, 199, 208);
}
/*鼠标悬停样式*/
.main-carousel>>>.VueCarousel-navigation-button>span:hover{
    color: #fff;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.137);
}
/* 小圆点 */
.main-carousel>>>.VueCarousel-pagination{
    position: absolute;
    bottom: 15px;
}
.main-carousel>>>.VueCarousel-dot-container{
    float: right;
    margin-right: 50px;
}
</style>
